export default __webpack_public_path__ + "static/media/cmc-active.6e563ddd.svg";